import React from "react";

function IntellectualProperty() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Intellectual Property</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              This area involves trademarks, copyrights and patents.  They are mainly designed for the sake of protecting the client and the client’s goodwill.    Any infringements will mean that there could be a possible litigation element involved.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default IntellectualProperty;
